export const services = {
  exterior: 'exterior',
  interior: 'interior',
  basic: 'basic',
  mini: 'mini',
  pro: 'pro',
  full: 'full',
  ultra: 'ultra',
  screenwash: 'screenwash',
  wax: 'wax',
  deepCleanSeat: 'deepCleanSeat',
  pet: 'pet',
  odourRemoval: 'odourRemoval',
  alloyWheelsSealant: 'alloyWheelsSealant',
  hdwax: 'hdwax',
  sanitisation: 'sanitisation',
  softroof: 'softroof',
  clayBarAndPolish: 'clayBarAndPolish',
  paintProtection: 'paintProtection',
  largeCar: 'largeCar',
  sameDay: 'sameDay',
  congestionZone: 'congestionZone'
}
